// extracted by mini-css-extract-plugin
export default {"dynamic-info-container":"DynamicInfoContainer_dynamic-info-container__--2OG","info-grid":"DynamicInfoContainer_info-grid__+Vvt2"};